type RuntimeConfigSnapshot = {
  enableDebugMode?: boolean;
  logLevel?: string;
};

type RuntimeWindow = Window & {
  __vwRuntimeConfig?: RuntimeConfigSnapshot;
};

function getRuntimeConfig(): RuntimeConfigSnapshot | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return (window as RuntimeWindow).__vwRuntimeConfig;
}

function isDebugEnabled(): boolean {
  return getRuntimeConfig()?.enableDebugMode === true;
}

export const runtimeLogger = {
  isDebugEnabled: (): boolean => isDebugEnabled(),

  debug: (...args: unknown[]): void => {
    if (isDebugEnabled()) {
      console.log(...args);
    }
  },

  info: (...args: unknown[]): void => {
    if (isDebugEnabled()) {
      console.info(...args);
    }
  },

  warn: (...args: unknown[]): void => {
    if (isDebugEnabled()) {
      console.warn(...args);
    }
  },

  error: (...args: unknown[]): void => {
    console.error(...args);
  }
};
